import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search',
  pure: false,
})
export class SearchPipe<T extends any> implements PipeTransform {
  transform(value: T[], [term]): T[] {
    // To lower case
    term = term.toLowerCase();

    if (value && value.length && term && term.length) {
      const val = value.filter(item => {
        return this.search(item, [term]);
      });

      if (val.length === 0) {
        return [];
      }

      return val;
    }
    return value;
  }

  private search(item, [term]) {
    for (const key in item) {
      if (
        typeof item[key] === 'string' &&
        item[key].toLowerCase().indexOf(term) !== -1
      ) {
        return true;
      } else if (typeof item[key] === 'object') {
        if (this.search(item[key], [term])) {
          return true;
        }
      }
    }
    return false;
  }
}
